// extracted by mini-css-extract-plugin
module.exports = {"plate":"gradientPlate_plate__WVUIL","hide":"gradientPlate_hide__Zj9o8"};